import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * ResetPasswordRedirect
 * 
 * This component handles redirects from various reset password URL formats
 * and ensures they all end up at the correct /reset-password/:token route
 */
export function ResetPasswordRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract token from query parameters (primary method from platform)
    const searchParams = new URLSearchParams(location.search);
    const pathname = location.pathname;
    
    let token = '';
    
    // Primary: Check query parameters (platform will send token as ?token=XXX)
    token = searchParams.get('token') || searchParams.get('t') || '';
    
    // Fallback: Check if token is in the URL path (for backward compatibility)
    if (!token) {
      if (pathname.includes('reset-password/')) {
        // Format: /reset-password/{token}
        token = pathname.split('reset-password/')[1];
      } else if (pathname.includes('reset/')) {
        // Alternative format: /reset/{token}
        token = pathname.split('reset/')[1];
      }
    }
    
    // If we found a token, redirect to the correct route
    if (token) {
      // Clean the token (remove any trailing slashes or query params)
      token = token.split('?')[0].split('/')[0];
      navigate(`/reset-password/${token}`, { replace: true });
    } else {
      // No token found, redirect to forgot password page
      navigate('/forgot-password', { 
        replace: true,
        state: { 
          error: 'Invalid reset link. Please request a new password reset.' 
        }
      });
    }
  }, [navigate, location]);

  // Show loading state while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to password reset...</p>
      </div>
    </div>
  );
}
